import { toggleDataActive } from '../utils/toggle-dataset';
import { addSpinner } from '../utils/add-spinner';
import { barProgress } from '../utils/bar-progress';
import { $Q } from '../utils/query-selector';
import { callbackSlider } from './slider-component';
import { getRecommendation } from './upsell-api';
import { createInterception } from '../utils/script-defer';
import { validateRemoteLocal } from './cart-async';
import ItemCart from './item-cart';
import { loadScriptProductCard } from './sections-defer';

/**
 * Cart scripts
 * The goal script is only charge logic in action cart
 */
export const sidecartDefer = async () => {
  const cartBtn = $Q('.cart-open-js');
  const cart = $Q('#shopify-section-side-cart');
  if (!cartBtn) return;

  toggleDataActive('.cart-open-js', '#shopify-section-side-cart', {
    overlay: true,
    closeSelector: '#cart-close-js',
  });

  if (cart) createInterception(cart, () => loadChangeCart(cart));
  if (cart) createInterception(cart, () => validateRemoteLocal());
};

/**
 * @param {HTMLElement} referenceParent - Reference parent node of upsell slider
 * @param {HTMLElement} cart - Define the cart type: side-cart or cart-page
 * @returns {Void} Build slider: web component
 */
export const loadUpsellCart = async (cart) => {
  const sliderUpsell = $Q('.slider-js.swiperElupsellsidecart', cart);

  if (!sliderUpsell) return;

  const slider = await callbackSlider(sliderUpsell);
  return slider;
};

/**
 * Mount all actions cart:
 * Upsell by API, Progress Bar, Icons slider, Item cart actions (update and delete)
 * @param {HTMLElement} cart - Define the cart type: side-cart or cart-page
 */
export const loadChangeCart = async (cart) => {
  const sliderIcons = $Q('.slider-js.swiperElresurrancecart', cart);

  const mountUpsell = await interfaceUpsell(cart);
  if (mountUpsell.length > 0) {
    const [onPage] = mountUpsell;
    if (!onPage) {
      await loadUpsellCart(cart);
    }
  }

  await loadScriptProductCard();
  await callbackSlider(sliderIcons);
  window.customElements.define('item-cart', ItemCart);
  barProgress($Q('#progress-bar-data', cart), cart);
};

// eslint-disable-next-line complexity
export const interfaceUpsell = async (cart, target = null) => {
  const referenceUpsell = '#cart-upsell-slider';
  const containerUpsell = $Q(referenceUpsell, target || cart);

  if (!containerUpsell) return [];

  const { dataset: { product, page } } = containerUpsell;
  const onPage = page === 'true' || false;
  const section = onPage ? 'cart-upsell' : 'side-cart';

  if (product !== "") {
    addSpinner(referenceUpsell);
    await getRecommendation({
      product,
      reference: referenceUpsell,
      section,
      onRender: '#upsell-js',
      scope: cart,
    });
  }

  return [onPage, product];
}
